module.exports = __webpack_public_path__ + "img/fiorimpopoli3.e77ef751.jpeg";